import { render, staticRenderFns } from "./StockIssuedSummaryReportView.vue?vue&type=template&id=0dd2bc31"
import script from "./StockIssuedSummaryReportView.vue?vue&type=script&lang=js"
export * from "./StockIssuedSummaryReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports